var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"swiper_warp"},[_c('swiper',{attrs:{"options":_vm.swiperOption}},[_c('swiper-slide',[_c('img',{staticClass:"swiper_slide",attrs:{"src":"http://test.00800.com.cn/pc/banner_1.jpg"}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }